import {  Carousel, ProductsCarousel, MenuItemsCarousel } from "@peracto/peracto-blocks-tailwind";

import Container from "./Container";
import Products from "./Products";

export default {
  plugins: {
    content: [Carousel, ProductsCarousel, MenuItemsCarousel, Products],
    layout: [Container],
  },
};
